import axiosInstance from "../config/axios.config";
import {
  extractPrintableHtml,
  openPrintWindow,
} from "../helpers/printDocument";

export { openPrintWindow };

export const generatePharmacyBillApi = (orderId, payload) => {
  return axiosInstance.post(`pharmacy/orders/${orderId}/generate-bill/`, payload);
};

export const getPharmacyBillsListApi = (params) => {
  return axiosInstance.get(`pharmacy/bills/?${params}`);
};

export const getPharmacyBillApi = (id) => {
  return axiosInstance.get(`pharmacy/bills/${id}/`);
};

// Narrowly scoped to one admission (nurse-accessible) - unlike getPharmacyBillsListApi,
// which is the pharmacist/admin-only whole-organization bill list.
export const getPharmacyBillsForAdmissionApi = (params) => {
  return axiosInstance.get(`pharmacy/bills/for-admission/?${params}`);
};

/**
 * Open bills a customer's next order can go onto, newest first. Takes either
 * `patient=<id>` or `counter_sale_customer=<id>`; cancelled bills are left out.
 *
 * Only Patient and Counter Sale orders can be put on an existing bill - IP and
 * OP orders bill against their admission.
 */
export const getPharmacyBillsForCustomerApi = (params) => {
  return axiosInstance.get(`pharmacy/bills/for-customer/?${params}`);
};

export const getPharmacyMedicineHistoryApi = (params) => {
  return axiosInstance.get(`pharmacy/bills/medicine-history/?${params}`);
};

export const getPharmacyBillPaymentsApi = (billId) => {
  return axiosInstance.get(`pharmacy/bills/${billId}/payments/`);
};

export const recordPharmacyPaymentApi = (billId, payload) => {
  return axiosInstance.post(`pharmacy/bills/${billId}/payments/`, payload);
};


export const pharmacyPaymentReceiptApi = (billId, params) => {
  return axiosInstance.post(
    `pharmacy/bills/${billId}/payments/receipt/?${params}`
  );
};

export const printPharmacyBillApi = (id, params) => {
  return axiosInstance.get(`pharmacy/bills/${id}/?${params}`);
};


export const printPharmacyBill = async (id, type) => {
  const resp = await printPharmacyBillApi(id, `print=${type}`);
  const html = extractPrintableHtml(resp?.data);
  if (!html) {
    throw new Error(
      resp?.data?.message || `No printable ${type} was returned for this bill`
    );
  }
  openPrintWindow(html);
};
